var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04851 8.98931C7.95846 8.9803 7.8504 8.9803 7.75135 8.98931C5.60818 8.91727 3.90625 7.16131 3.90625 5.00013C3.90625 2.79393 5.68922 1.00195 7.90443 1.00195C10.1106 1.00195 11.9026 2.79393 11.9026 5.00013C11.8936 7.16131 10.1917 8.91727 8.04851 8.98931Z",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.578 2.80273C16.325 2.80273 17.7297 4.21651 17.7297 5.95445C17.7297 7.65638 16.379 9.04314 14.6951 9.10617C14.623 9.09717 14.542 9.09717 14.4609 9.10617",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54845 12.3121C1.36927 13.7709 1.36927 16.1482 3.54845 17.598C6.0248 19.2549 10.086 19.2549 12.5624 17.598C14.7416 16.1392 14.7416 13.7619 12.5624 12.3121C10.095 10.6642 6.03381 10.6642 3.54845 12.3121Z",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3203 17.2106C16.9687 17.0755 17.581 16.8143 18.0853 16.4271C19.49 15.3736 19.49 13.6356 18.0853 12.582C17.59 12.2038 16.9867 11.9517 16.3473 11.8076",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayesIcon);
export default __webpack_public_path__ + "static/media/playesIcon.b72d8667d23d6a08bd1954ae8e512aa1.svg";
export { ForwardRef as ReactComponent };